import Chart from 'react-apexcharts';

const ChartContainer = ({
    title,
    options,
    series,
    type = 'bar',
    height = 350,
    className = ''
}) => {
    return (
        <div className={`chart-container-dashboards ${className}`}>
            <h3 className="chart-title">{title}</h3>
            <div style={{ width: '100%' }}>
                <Chart
                    options={options}
                    series={series}
                    type={type}
                    height={height}
                    width="100%"
                />
            </div>
        </div>
    );
};

export default ChartContainer;
